import { PosthogTrackingSource } from '@terminal/services/tracking/posthog/constants';
import { CatalystDrawerParams } from '@terminal/widgets/catalyst-insights-drawer/useCatalystDrawer';
import {
  SubTabsType,
  UsEarningsInsightDrawerReturn,
} from '@terminal/widgets/earnings-insight-drawer/useEarningsInsightDrawer';
import { MarketCatalystDrawerParams } from '@terminal/widgets/market-catalyst-drawer/useMarketCatalystDrawer';

import { PulseSentimentInsight } from '../pulse-types';

type KgInsightDrawerSource = Pick<
  PulseSentimentInsight,
  'id' | 'category' | 'subcategory' | 'subjectThemeId' | 'company' | 'earnings'
>;

export const openDrawerForKgInsight = ({
  insight,
  source,
  fallbackThemeId,
  openMarketCatalystDrawer,
  openCatalystDrawer,
  openEarningsInsightDrawer,
}: {
  insight: KgInsightDrawerSource;
  source: PosthogTrackingSource;
  fallbackThemeId?: string;
  openMarketCatalystDrawer: (params: MarketCatalystDrawerParams) => void;
  openCatalystDrawer: (params: CatalystDrawerParams) => void;
  openEarningsInsightDrawer: UsEarningsInsightDrawerReturn['openDrawer'];
}) => {
  if (insight.category === 'market_catalyst') {
    openMarketCatalystDrawer({
      type: insight.subcategory ?? 'thematic',
      themeId: insight.subjectThemeId ?? fallbackThemeId,
      insightId: insight.id,
      source,
    });
    return;
  }

  if (insight.company && insight.earnings) {
    openEarningsInsightDrawer({
      entityTag: insight.company.entityTag,
      earningsId: insight.earnings.id,
      insightId: insight.id,
      subtab:
        insight.earnings.category === 'earnings_preview'
          ? SubTabsType.Preview
          : SubTabsType.Recap,
      source,
    });
    return;
  }

  if (insight.company) {
    openCatalystDrawer({
      type: 'company',
      entityTag: insight.company.entityTag,
      insightId: insight.id,
      source,
    });
  }
};
